import { render } from "./FormHeader.vue?vue&type=template&id=7047ff5c&scoped=true"
import script from "./FormHeader.vue?vue&type=script&lang=js"
export * from "./FormHeader.vue?vue&type=script&lang=js"

import "./FormHeader.vue?vue&type=style&index=0&id=7047ff5c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2653157369/src/mchanga-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7047ff5c"]])

export default __exports__